import React, { useRef, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange, testId = "signature-pad" }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const strokes = useRef(0);

  useEffect(() => {
    const cv = ref.current;
    const init = () => {
      const ratio = window.devicePixelRatio || 1;
      cv.width = cv.offsetWidth * ratio;
      cv.height = cv.offsetHeight * ratio;
      const ctx = cv.getContext("2d");
      ctx.scale(ratio, ratio);
      ctx.lineWidth = 2.2;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.strokeStyle = "#0B2545";
    };
    init();
    let w = cv.offsetWidth;
    const ro = new ResizeObserver(() => {
      if (cv.offsetWidth === w) return;
      w = cv.offsetWidth;
      init();
      strokes.current = 0;
      onChange("");
    });
    ro.observe(cv);
    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    try { ref.current.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
    strokes.current += 1;
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(strokes.current > 8 ? ref.current.toDataURL("image/png") : "");
  };
  const clear = () => {
    const cv = ref.current;
    cv.getContext("2d").clearRect(0, 0, cv.width, cv.height);
    strokes.current = 0;
    onChange("");
  };

  return (
    <div className="space-y-1">
      <div className="relative rounded-lg border-2 border-dashed border-navy/30 bg-white">
        <canvas ref={ref} className="h-36 w-full touch-none cursor-crosshair" onPointerDown={down} onPointerMove={move}
          onPointerUp={up} onPointerLeave={up} data-testid={testId} />
        <span className="pointer-events-none absolute bottom-2 left-3 text-[11px] text-slate-400">Sign here with your finger or mouse</span>
      </div>
      <Button type="button" variant="ghost" size="sm" onClick={clear} data-testid={`${testId}-clear`}>
        <Eraser className="mr-1 h-3.5 w-3.5" />Clear
      </Button>
    </div>
  );
};
